module.exports = __webpack_public_path__ + "img/landing-2-hr-HR.0b1c114.png";